/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type UserEntity, userSchema } from '@axiom/domain';
import { makeRequired } from '@axiom/types';

export const eSUserDAOSchema = userSchema.pick({ "createdAt": true, "email": true, "firstName": true, "fullName": true, "id": true, "lastName": true }).extend({ "createdAt": makeRequired(userSchema.shape.createdAt) });
export type ESUserDAO = Pick<UserEntity, "createdAt" | "email" | "firstName" | "fullName" | "id" | "lastName"> & z.infer<typeof eSUserDAOSchema>;
